export default {
  "article.relatedTitle": "相关文章推荐",
  "article.publishedAt": "发布于",
  "article.updatedAt": "更新于",
  "article.readTime": "阅读时间",
  "article.minRead": "分钟",
  "article.author": "作者",
  "article.share": "分享",
  "article.category": "分类",
  "article.backToList": "返回列表",
  "article.previous": "上一篇",
  "article.next": "下一篇",
}